import React from 'react';
import { 
  Facebook, 
  Twitter, 
  Instagram, 
  Linkedin, 
  MapPin, 
  Phone, 
  Mail 
} from 'lucide-react';

const Footer = () => {
  return (
    <footer className=" border-t border-green-400/10 pt-16 pb-8 relative overflow-hidden">
      {/* Background Decorative Glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[500px] h-[200px] bg-blue-600/5 blur-[100px] pointer-events-none" />

      <div className="max-w-[1400px] mx-auto px-6 md:px-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          {/* Brand Column */}
          <div className="space-y-1">
            <div className="flex items-center">
              <a href="/" className="transition-opacity hover:opacity-80">
                <img 
                  src="/logo.png" 
                  alt="SecuWall Logo" 
                  className="h-10 w-auto object-contain" 
                />
              </a>
            </div>

            <div className="flex flex-col mt-2">
              <p className="text-white text-xs font-black tracking-[0.1em] uppercase leading-none">
                Decode
              </p>
              <p className="text-green-500 text-xs font-black tracking-[0.1em] uppercase leading-none mt-1">
                Secure
              </p>
              <p className="text-white text-xs font-black tracking-[0.1em] uppercase leading-none mt-1">
                Defend
              </p>
              <div className="h-1 w-6 bg-green-500 mt-1"></div>

              {/* ISO Logos Section */}
              <div className="flex items-center gap-2 mt-4">
                <img 
                  src="/27000.png" 
                  alt="ISO 27001" 
                  className="h-10 w-auto opacity-80 hover:opacity-100 transition-opacity hover:grayscale-0" 
                />
                <img 
                  src="/20000.png" 
                  alt="ISO 20000" 
                  className="h-10 w-auto opacity-80 hover:opacity-100 transition-opacity hover:grayscale-0" 
                />
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-6 text-sm uppercase tracking-widest">Services</h4>
            <ul className="space-y-4 text-slate-400 text-sm">
              <li><a href="https://secu-wall.com/solutions-mdr" className="hover:text-blue-400 transition-colors">Manage Defence</a></li>
              <li><a href="https://secu-wall.com/Tactical/" className="hover:text-blue-400 transition-colors">Tactical Services</a></li>
              <li><a href="https://secu-wall.com/tech-reselling" className="hover:text-blue-400 transition-colors">Tech & Reselling</a></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-semibold mb-6 text-sm uppercase tracking-widest">Company</h4>
            <ul className="space-y-4 text-slate-400 text-sm">
              <li><a href="https://secu-wall.com/CompanyInfo" className="hover:text-blue-400 transition-colors">About Us</a></li>
              <li><a href="https://secu-wall.com/careers" className="hover:text-blue-400 transition-colors">Career</a></li>
              <li><a href="https://secu-wall.com/CompanyInfo/#contact-section" className="hover:text-blue-400 transition-colors">Contact</a></li>
            </ul>
          </div>

          {/* Location and Socials */}
          <div className="space-y-5">
            {/* Location Header */}
            <div>
              <h4 className="text-white font-semibold text-sm uppercase tracking-widest mb-3">Location</h4>
              <p className="text-green-100/60 text-sm leading-relaxed">
                Rangs Naharz, 14 Shah Jalal Avenue
                <br />
                Sector 4, Uttara, Dhaka-1230
              </p>
              {/* Phone */}
              <div className="flex items-center gap-3 text-green-100/60 text-sm">
                  <Phone size={18} className="text-green-500 shrink-0" />
                  <p>
                    <a href="tel:+880248954441" className="hover:text-green-400 transition-colors">
                      +88 02 4895 4441-2
                    </a>
                  </p>
              </div>
              {/* Email */}
              <div className="flex items-center gap-3 text-green-100/60 text-sm">
                  <Mail size={18} className="text-green-500 shrink-0" />
                  <p>
                    <a href="mailto:support@secu-wall.com" className="hover:text-green-400 transition-colors">
                      support@secu-wall.com
                    </a>
                  </p>
              </div>
            </div>

            {/* Social Icons */}
            <div className="space-y-3">
              <div className="flex gap-1">
                {[
                  { icon: <Facebook size={18} />, url: "https://www.facebook.com/profile.php?id=61582331513074", label: "Facebook" },
                  { icon: <Twitter size={18} />, url: "https://x.com/secuwall", label: "X" },
                  { icon: <Instagram size={18} />, url: "https://www.instagram.com/secuwall?igsh=cjQ2bmdsZDVheHpu", label: "Instagram" },
                  { icon: <Linkedin size={18} />, url: "https://www.linkedin.com/company/104847044/", label: "Linkedin" }
                ].map((social, i) => (
                  <a
                    key={i}
                    href={social.url}
                    aria-label={social.label}
                    className="w-8 h-8 rounded-lg bg-green-500/10 border border-green-500/20 flex items-center justify-center text-green-400 hover:bg-green-500 hover:text-black hover:-translate-y-1 transition-all duration-300"
                  >
                    {social.icon}
                  </a>
                ))}
              </div>             
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-green-400/10 flex flex-col md:row justify-between items-center gap-4 text-[11px] text-slate-500 uppercase tracking-widest font-medium">
          <p>© 2025 SecuWall Technologies. All Rights Reserved.</p>
          
        </div>
      </div>
    </footer>
  );
};

export default Footer;